<template>
  <div class="performance__chart-wrapper">
    <component
      :is="chartNode['type']"
      :value="chartNode"
      v-if="chartNode"
      @deleteChart="$emit('deleteChart')"
    />
  </div>
</template>

<script>
// Components
import { VerticalBarChart, HorizontalBarChart, HorizontalLineChart } from '@/pigeondoc/wrapper';

export default {
  name: 'PerformanceChart',
  components: {
    VerticalBarChart,
    HorizontalBarChart,
    HorizontalLineChart,
  },
  props: {
    chartNode: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: () => '',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
